import React from 'react';
import { TextField, Typography } from '@mui/material';
import { colors } from '../../../theme';

interface StyledTextFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  rows?: number;
  helperText?: string;
  multiline?: boolean;
}

export const StyledTextField: React.FC<StyledTextFieldProps> = ({
  value,
  onChange,
  placeholder,
  rows = 3,
  helperText,
  multiline = true,
}) => {

  return (
    <>
      <TextField
        multiline={multiline}
        rows={multiline ? rows : undefined}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        fullWidth
        sx={{
          '& .MuiOutlinedInput-root': {
            backgroundColor: colors.softWhite,
            borderRadius: '8px',
            '& fieldset': {
              borderColor: colors.slate[200],
            },
            '&:hover fieldset': {
              borderColor: colors.slate[400],
            },
            '&.Mui-focused fieldset': {
              borderColor: colors.signalOrange,
            },
          },
        }}
      />
      {helperText && (
        <Typography
          sx={{
            fontSize: '0.75rem',
            color: colors.slate[500],
            marginTop: '8px',
            fontStyle: 'italic',
          }}
        >
          {helperText}
        </Typography>
      )}
    </>
  );
};
